<template>
    <vx-card class="bulk-page">
      <div class="loader-block loader-block2" v-if="isLoading">
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </div>
      <h2 class="vx-col w-full mb-10" style="text-align: center; margin: 0 0 20px 0">Bulk publish</h2>

      <div class="vx-row mb-16">
        <div class="bulk-email-block">
          <div class="bulk-email-wrapper" :class="{'no-edit': !withEmail}">
            <vx-input-group class="custom-input-group mb-0 mr-5">
              <template slot="prepend">
                <div class="prepend-text bg-dark">
                  Email
                </div>
              </template>
              <vs-input
                name="email"
                type="email"
                placeholder="Email"
                style="min-width: 300px;"
                v-model="email"
              />
            </vx-input-group>
          </div>
          <div class="with-email">
            Send to email <vs-switch v-model="withEmail" />
          </div>
        </div>

        <vx-input-group class="custom-input-group mb-0 mr-5">
          <template slot="prepend">
            <div class="prepend-text bg-dark">
              File
            </div>
          </template>
          <div class="d-flex">
            <div class="vs-inputx vs-input--input normal custom-vs-input" @click="selectFile">
              {{ fileName ? fileName : 'Select file' }}
            </div>
          </div>
        </vx-input-group>
        <vs-button class="shadow-lg" type="gradient" :disabled="isLoading || (!email && withEmail) || !file" @click="bulkPublish">Publish</vs-button>
      </div>
      <div class="vx-row" v-if="s3FileUrl">
        <a :href="s3FileUrl" class="bulk-download-link">Download CSV report</a>
      </div>

    </vx-card>
</template>

<script>

export default {
  name: 'BulkPublish',
  components: {
  },
  head() {
    return {
      title: {
        inner: 'AMP',
        separator: ' ',
        complement: ''
      },
      meta: [
        {hid: 'description', name: 'description', content: ''}
      ]
    }
  },
  data() {
    return {
      isLoading: false,
      withEmail: true,
      file: null,
      email: this.$store.state.user.email,
      fileName: null,
      s3FileUrl: null
    }
  },
  computed: {},
  mounted() {

  },
  methods: {
    selectFile() {
      this.file = null;
      this.fileName = null;
      let input = document.createElement("input");
      input.type = "file";
      input.accept = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
      input.click();
      input.addEventListener("change", (e) => {
        this.file = e.target.files[0];
        this.fileName = this.file.name;
        input.remove();
      })
    },
    bulkPublish() {
      this.s3FileUrl = null;
      this.isLoading = true;
      let url = `/bulk-publish`;

      let formData = new FormData();
      formData.append("file", this.file);
      if (this.withEmail) {
        formData.append("email", this.email);
      } else {
        formData.append("without_email", true);
      }

      this.$axios.post(url, formData).then(res => {
        this.isLoading = false;
        if (res.data.error) {
          this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: res.data.error})
        } else {
          if (res.data.warning) {
            this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: res.data.warning})
          }
          if (res.data.s3FileUrl) {
            this.s3FileUrl = res.data.s3FileUrl;
            this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Success', text: 'Assets successfully published'})
          }
        }
      }).catch(e => {
        console.log(e)
        this.isLoading = false;
        this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: e.message || e})
      });
    }
  },
}
</script>
